import { CloseIcon } from '../svg-icons';
import { RewardModalWrapper } from '@/components/reward-modal-wrapper';
import { useReward } from '@/contexts/reward-context';

export const UM = () => {
	const { labels, onClose } = useReward();

	return (
		<RewardModalWrapper>
			<div className="reward-notice">
				<div
					className="reward-notice__btn-close"
					onClick={onClose}
				>
					<CloseIcon />
				</div>
				<div className="reward-notice__head" />
				<div className="reward-notice__content">
					<div className="reward-notice__scroll">
						<div className="reward-notice__title">{labels?.lbl_SBCAUMPage}</div>
						<div className="reward-notice__title">Prepare for the brand-new SABA reward system, Coming soon.</div>
						<div
							className="reward-notice__title"
							style={{ borderBottom: 'none', paddingBottom: 0 }}
						>
							Chuẩn bị cho hệ thống phần thưởng SABA hoàn toàn mới, sắp ra mắt.
						</div>
					</div>
				</div>
				<div className="reward-notice__footer" />
			</div>
		</RewardModalWrapper>
	);
};